import api from "../../../api";
import React, { useContext, useEffect } from "react";
import utils from "../../../utils";
import values from "../../../values";
import Context from "../../../context";
import UserScreen from "../index";

import { TModal } from "../../../types/common.type";
import { useQuery } from "react-query";
import {
  ICreateAndUpdateTicket,
  IReplyTicket,
  IRequestTicket,
} from "../../../types/ticket.interface";

const TicketContainer = () => {
  // ** ====================================================================================================================
  // ** --------------------------------------------------------------------------------------------------------------------
  // **                                               Value Validations
  // ** --------------------------------------------------------------------------------------------------------------------

  const [showModal, setShowModal] = React.useState<TModal>("NONE");
  const [loading, setLoading] = React.useState<boolean>(false);
  const [selectedTicket, setSelectedTicket] = React.useState<any>();
  const [requestTicket, setRequestTicket] = React.useState<IRequestTicket>({
    page: 1,
    limit: values.constants.PANEL_TABLE_DEFAULT_LIMIT,
    search: { base: "", value: "" },
  });

  const { userInfo } = useContext(Context.AppContext);
  // ** --------------------------------------------------------------------------------------------------------------------
  // ** ====================================================================================================================

  // !! ====================================================================================================================
  // !! --------------------------------------------------------------------------------------------------------------------
  // !!                                                Start API Cal
  // !! --------------------------------------------------------------------------------------------------------------------
  // const resultTicket = { data: { result: { docs: [] } } };

  const resultTicket = useQuery(
    [
      values.useQueryKeys.getAllTicket,
      requestTicket?.page,
      requestTicket?.search?.value,
      requestTicket?.filters,
    ],
    () =>
      api.getMethod.common.findTicket({
        filters: requestTicket?.filters,
        search: requestTicket?.search,
        limit: requestTicket?.limit,
        page: requestTicket?.page,
      })
  );
  const refetchTickets = resultTicket.refetch;

  // !! --------------------------------------------------------------------------------------------------------------------
  // !! ====================================================================================================================

  // ** ====================================================================================================================
  // ** --------------------------------------------------------------------------------------------------------------------
  // **                                               Local Functions
  // ** --------------------------------------------------------------------------------------------------------------------

  useEffect(() => {
    setSelectedTicket(
      resultTicket?.data?.result?.docs?.find(
        (item: any) => item?._id === selectedTicket?._id
      )
    );
  }, [resultTicket]);

  async function replyTicketFunction(formData: IReplyTicket) {
    setLoading(true);
    const result = await api.postMethod.common.replyTicket(formData);
    if (result) {
      utils.successHandler(Number(2010)); // result.CODE === 2021
      resultTicket.refetch();
      // setShowModal("NONE");
      setLoading(false);
      return true;
    }
    setLoading(false);
    return false;
  }
  async function createTicket(formData: ICreateAndUpdateTicket) {
    setLoading(true);
    const result = await api.postMethod.common.createTicket({
      ...formData,
      user: userInfo?.data?.result?._id,
    });
    if (result) {
      utils.successHandler(Number(2010)); // result.CODE === 2021
      resultTicket.refetch();
      setShowModal("NONE");
    }
    setLoading(false);
    return false;
  }
  async function updateTicket(formData: ICreateAndUpdateTicket) {
    // setIsLoading(true);
    // const result = await api.put.administrator.updateAdmin(formData);
    // if (result) {
    //   utils.successHandler(Number(2010)); // result.CODE === 2021
    //   resultTicket.refetch();
    //   setShowModal("NONE");
    // }
    // setIsLoading(false);
    return false;
  }

  // async function deleteFunction(userId: string) {
  //   setIsLoading(true);
  //   const result = await api.dele.administrator.deleteUser(userId);
  //   if (result) {
  //     utils.successHandler(Number(2010)); // result.CODE === 2021
  //     // resultTicket.refetch();
  //     setShowModal("NONE");
  //   }
  //   setIsLoading(false);
  //   return false;
  // }
  // ** --------------------------------------------------------------------------------------------------------------------
  // ** ====================================================================================================================

  // ?? ====================================================================================================================
  // ?? --------------------------------------------------------------------------------------------------------------------
  // ??                                                JSX Container
  // ?? --------------------------------------------------------------------------------------------------------------------
  return (
    <Context.TicketContext.Provider
      value={{
        showModal,
        loading,
        setShowModal,
        setLoading,
        updateTicket,
        createTicket,
        requestTicket,
        selectedTicket,
        setRequestTicket,
        setSelectedTicket,
        replyTicketFunction,
        refetchTickets,
      }}
    >
      <UserScreen rqUser={resultTicket} />
      {/* <DeleteModal
        open={showModal === "DELETE"}
        user={selectedUser}
        data={selectedUser}
        loading={isLoading}
        onClose={() => setShowModal("NONE")}
        onSubmit={deleteFunction}
      /> */}
    </Context.TicketContext.Provider>
  );

  // ?? --------------------------------------------------------------------------------------------------------------------
  // ?? ====================================================================================================================
};

export default TicketContainer;
